<template lang="pug">
.card(:class="{completed: event.completed || event.eventOptions.status === 'defeat', 'new-activity': getFilteredActivity.length > 0}")
  .header.d-flex.justify-content-between(@click='view(getFilteredActivity.length > 0 ? "activity" : "detail")')
    svg(v-if='event.eventOptions.integration === "github"', xmlns='http://www.w3.org/2000/svg', width='25', height='24', viewbox='0 0 25 24')
      path(fill-rule='evenodd', d='M12.304 0C5.51 0 0 5.508 0 12.304c0 5.436 3.525 10.048 8.414 11.675.615.114.84-.267.84-.592 0-.293-.01-1.263-.016-2.29-3.423.744-4.145-1.452-4.145-1.452-.56-1.423-1.366-1.8-1.366-1.8-1.117-.764.084-.749.084-.749 1.235.087 1.886 1.268 1.886 1.268 1.097 1.881 2.878 1.337 3.58 1.023.11-.795.43-1.338.782-1.645-2.733-.311-5.606-1.367-5.606-6.081 0-1.343.48-2.44 1.268-3.302-.128-.31-.55-1.562.119-3.257 0 0 1.033-.33 3.384 1.262.982-.273 2.034-.41 3.08-.414 1.045.004 2.099.141 3.082.414 2.349-1.592 3.38-1.262 3.38-1.262.67 1.695.249 2.947.12 3.257.79.861 1.267 1.959 1.267 3.302 0 4.726-2.878 5.766-5.618 6.071.441.382.835 1.13.835 2.278 0 1.647-.015 2.972-.015 3.377 0 .327.222.711.846.59 4.886-1.628 8.407-6.239 8.407-11.673C24.608 5.508 19.098 0 12.304 0')
    img(v-else, src='../../assets/habitica-grey.svg')
    .callout(v-if='!event.completed && event.recentActivity.length > 0')
      | {{ getNewActivityCount }}
    .completed-title.d-flex.justify-content-between(v-else-if='event.completed')
      img(src='../../assets/left-glitter.svg')
      div Completed!
      img(src='../../assets/right-glitter.svg')
    completed-title(v-else-if='defeated')
      div Defeated
    div(v-else) Battle Event
    .spacer
  .details.d-flex.justify-content-between(@click='view()')
    .wrap(v-if='event && event.eventOptions && favoriteMonster')
      sprite-render.sprite(:sprite='event.eventOptions')
      .name(v-if='event && !event.eventOptions.spriteTokenId') {{ spriteName }}
      .name(v-else-if='event && event.eventOptions.spriteTokenId && !spriteName') Sprite {{`#${eventData.eventOptions.spriteTokenId}`}}
      .name(v-else) {{ spriteName }}
      .progress-bar
        .progress-fill(:style='{width: spriteHealthPercent + "%"}')
      .exp-text {{ spriteHealth }} / 50 HP
    .d-flex.align-items-center
      img.versus(src='../../assets/vs.svg')
    .wrap
      img.sprite.sprite2(v-if='event.eventOptions.boss === "boss1"',
        src='../../assets/enemies/1_uguu.png')
      img.sprite.sprite2(v-if='event.eventOptions.boss === "boss2"',
        src='../../assets/enemies/2_dandeepu.png')
      img.sprite.sprite2(v-if='event.eventOptions.boss === "boss3"',
        src='../../assets/enemies/3_marimissimo.png')
      img.sprite.sprite2(v-if='event.eventOptions.boss === "boss4"',
        src='../../assets/enemies/4_pyrite_crab.png')
      img.sprite.sprite2(v-if='event.eventOptions.boss === "boss5"',
        src='../../assets/enemies/5_soop.png')
      img.sprite.sprite2(v-if='event.eventOptions.boss === "boss6"',
        src='../../assets/enemies/6_nipish.png')
      img.sprite.sprite2(v-if='event.eventOptions.boss === "boss7"',
        src='../../assets/enemies/7_bunbun.png')
      img.sprite.sprite2(v-if='event.eventOptions.boss === "boss8"',
        src='../../assets/enemies/8_drogon.png')
      img.sprite.sprite2(v-if='event.eventOptions.boss === "boss9"',
        src='../../assets/enemies/9_fenix.png')
      .name(v-if='event.eventOptions.boss') {{ bossById[event.eventOptions.boss] }}
      .progress-bar
        .progress-fill(:style='{width: bossHealthPercent + "%"}')
      .exp-text {{ bossHealth }} / {{ bossHp }} HP
      b-tooltip(target="next-strike", title="This countdown tells you when the monster will attack! To strike at the monster and protect your Sprite, complete a task in the integration you chose for your event.")
      #next-strike.next-strike.text-center
        .title Next Strike
        .time {{ getNextAttackTime }}
  .review.d-flex.justify-content-center(v-if='event.completed')
    div.btn-green(@click='view()') Review
  .review.d-flex.justify-content-center(v-if='defeated')
    div.btn-red(@click='view()') Defeated
  .footer(@click='view("activity")')
    // button(@click='invite(event._id)') Invite
    div(v-if='event.recentActivity.length > 0')
      .recent-title Recent Activity
      .text-center(v-if='recentReason')
        vue-markdown(:source='recentReason')
      .text-center +5 dmg
    div(v-else)
      .recent-title Recent Activity
      .text-center Event started
</template>

<style lang="scss" scoped>
  .card:hover {
    box-shadow: 0 4px 8px 0 rgba(31, 31, 31, 0.16), 0 4px 8px 0 rgba(31, 31, 31, 0.24);
  }

  .new-activity {
    .callout {
      color: #3ba5a8;
    }

    .versus {
      fill: #3ba5a8;
    }
  }

  .card {
    border-radius: 8px;
    border: none;
    height: 100%;
    min-height: 150px;
    font-weight: bold;
    box-shadow: 0 2px 2px 0 rgba(31, 31, 31, 0.12), 0 0 2px 0 rgba(31, 31, 31, 0.12);
    transition: box-shadow ease-in .15s;
  }

  .next-strike {
    margin-top: 1rem;

    .title {
      text-transform: uppercase;
      font-size: 10px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.2;
      letter-spacing: normal;
      color: #6c6d69;
    }

    .time {
      font-size: 12px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: normal;
      text-align: center;
      color: #a1a39e;
    }
  }

  .completed-title {
    img {
      margin-right: .5rem;
      margin-left: .5rem;
    }
  }

  .details {
    min-height: 100px;
    padding: 1.2rem .8rem;

    .name {
      width: 80px;
      margin: 0 auto;
      font-size: 12px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: 0.5px;
      color: #6c6d69;
      margin-top: .5rem;
      margin-bottom: .5rem;
      text-align: center;
    }

    .wrap {
      width: 50%;
      padding: 1em;
    }

    .exp-text {
      width: 80px;
      margin: 0 auto;
      font-size: 12px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: 0.5px;
      color: #6c6d69;
      margin-top: .5rem;
      text-align: center;
    }

    .circle {
      width: 50px;
      height: 50px;
      background: #000;
      border-radius: 50%;
      margin: 0 auto;
      margin-bottom: .5em;
    }

    .sprite {
      margin: 0 auto;
      display: block;
      margin-bottom: .8em;
      min-height: 71px;
    }

    .sprite1 {
      width: 64px;
    }

    .sprite2 {
      height: 72px;
    }

    .progress-bar {
      margin-bottom: .5em;
      width: 78px;
      height: 4px;
      border-radius: 999px;
      background-color: #d7dad2;
      margin: 0 auto;
    }

    .progress-fill {
      background-color: #e14455;
      width: 20%;
      height: 4px;
      border-radius: 999px;
    }
  }

  .review {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -15px;
    margin-left: -60px;
  }

  .header {
    border-radius: 4px 4px 0px 0px;
    margin-bottom: .5em;
    width: 100%;
    padding: 1em;
    background-color: #f7f8f6;
    color: #6c6d69;
    font-size: 16px;
    font-weight: bold;

    svg {
      fill: #a1a39e;
    }

    .spacer {
      min-width: 24px;
    }
  }

  .completed {
    .header {
      color: #9bc75a;

      svg {
        fill: #fff;
      }
    }

    .details {
      opacity: 0.24;
    }
  }

  .footer {
    padding: 1rem .5rem;
    background: #f7f8f6;
    border-radius: 0 0 4px 4px;
    font-size: 12px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: center;
    color: #6c6d69;
    min-height: 80px;

    .recent-title {
      color: #a1a39e;
      margin-bottom: .2rem;
    }
  }
</style>

<script>
import moment from 'moment';
import VueMarkdown from 'vue-markdown';

import { bossById } from '../../lib/boss';
import SpriteRender from '../monsters/SpriteRender';

export default {
  props: ['event'],
  components: {
    SpriteRender,
    VueMarkdown,
  },
  data() {
    return {
      bossById,
    };
  },
  computed: {
    defeated() {
      return this.event.eventOptions.status === 'defeat';
    },
    recentReason() {
      const { event } = this;

      // @TODO: Share sort for github activity
      event.recentActivity.sort((a, b) => {
        const firstDate = a.remoteCreatedDate || a.createdAt;
        const secondDate = b.remoteCreatedDate || b.createdAt;

        return moment(firstDate).isBefore(secondDate);
      });

      if (!event.recentActivity || !event.recentActivity[0]) return '';
      return event.recentActivity[0].reason;
    },
    favoriteMonster() {
      return this.$store.state.favoriteMonster;
    },
    viewedActivityDates() {
      return this.$store.state.viewedActivityDates;
    },
    getFilteredActivity() {
      const event = this.event;

      const lastViewedDate = this.viewedActivityDates[event._id];

      const activity = event.recentActivity.filter((act) => {
        return lastViewedDate ? moment(lastViewedDate).isBefore(act.createdAt) : true;
      });

      return activity;
    },
    getNewActivityCount() {
      const event = this.event;

      const activity = this.getFilteredActivity;
      const { length } = activity;
      if (length === 0) return 'Battle Event';

      const plural = length > 1 ? 's' : '';

      return `${length} New Action${plural}!`;
    },
    spriteName() {
      const spriteName = this.event.eventOptions.sprite && this.event.eventOptions.sprite.name;
      return spriteName || this.event.eventOptions.spriteName;
    },
    bossHp() {
      const event = this.event;
      if (event.eventOptions.difficulty === 'hard') return 200;
      if (event.eventOptions.difficulty === 'nightmare') return 300;
      return 100;
    },
    bossHealth() {
      const event = this.event;
      return event && event.eventOptions && event.eventOptions.bossHealth ? event.eventOptions.bossHealth : this.bossHp;
    },
    bossHealthPercent() {
      const event = this.event;
      return (this.bossHealth / this.bossHp) * 100;
    },
    spriteHealth() {
      const event = this.event;
      return event && event.eventOptions && event.eventOptions.spriteHealth ? event.eventOptions.spriteHealth : 50;
    },
    spriteHealthPercent() {
      const event = this.event;
      return (this.spriteHealth / 50) * 100;
    },
    getNextAttackTime() {
      const event = this.event;
      if (event.completed) return '';

      const today = moment().utc();

      if (event.recentActivity.length === 0) {
        const eventCreated = moment(event.eventOptions.lastAttack || event.createdAt).utc();
        const diffEventCreated = today.diff(eventCreated, 'hours', true);
        return this.formatHourLeft(24 - diffEventCreated);
      }

      const activityDate = event.recentActivity[0].remoteCreatedDate || event.recentActivity[0].createdAt;
      const recentActivityDate = moment(activityDate).utc();
      const diffFromLastActivity = today.diff(recentActivityDate, 'hours', true);

      if (!event.eventOptions.lastAttack) {
        return this.formatHourLeft(24 - diffFromLastActivity);
      }

      const lastAttackDate = moment(event.eventOptions.lastAttack).utc();
      const diffFromLastAttack = today.diff(lastAttackDate, 'hours', true);

      if (lastAttackDate.isBefore(recentActivityDate)) {
        return this.formatHourLeft(24 - diffFromLastActivity);
      }

      return this.formatHourLeft(24 - diffFromLastAttack);
    },
  },
  methods: {
    view(page) {
      this.$root.$emit('show-event-detail', this.event._id, page);
    },
    formatHourLeft(time) {
      const hour = Math.floor(time);
      const minutes = Math.floor((time % 1) * 60);

      if (hour < 0 || minutes < 0) return 'Attacking now!';

      return `${hour}hr ${minutes}m`;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/events/EventItem.vue